"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const Titleheading = () => {
  return (
    <div>
      <section className="relative py-10 md:py-20 lg:py-40 -z-20 before:-z-10 before:bg-opacity-20">
        {/* Background Image using Next.js Image tag */}
        <Image
          src="/images/plane-1.jpg"
          alt="Background Image"
          fill
          className="absolute top-0 left-0 w-full h-full -z-10 object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-30 z-0"></div>

        <div className="max-w-screen-xl mx-5 lg:mx-auto relative z-10">
          <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
            {/* Heading and content */}
            {/* <h1 className="font-bold text-white text-3xl lg:text-5xl mb-3">
              Contact Us
            </h1>
            <p className="text-white text-lg">
              <a href="/" className="text-orange-600 hover:text-orange-300">
                Waveband Productions
              </a>{" "}
              / Contact Us
            </p> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Titleheading;
